import {SUPERCOMPANIES} from '@constants';
import {cleanUrl} from '@jobseeker/lotus/lib/utils';
import {Grid, Typography} from '@mui/material';
import {capitalizeFirstLetter} from '@utils';
import {Link} from '@jobseeker/lotus/lib/elements';
import React from 'react';

const Companies = () => {
  return (
    <>
      <Typography component="h2" mt={2} mb={1}>
        Company
      </Typography>
      <Grid container spacing={2} mb={1}>
        {SUPERCOMPANIES.map((company: string) => (
          <Grid item key={company} xs={4}>
            <Link href={`/${cleanUrl(company)}-careers`} target="_blank">
              {capitalizeFirstLetter(company)} Jobs
            </Link>
          </Grid>
        ))}
      </Grid>
      <Link href={`/sitemap/company-careers`}>See All Companies {'>>'}</Link>
    </>
  );
};

export default Companies;
